import React from 'react';
import './ConceptChooser.css';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import {TextField} from "@material-ui/core";
import {connect} from 'react-redux';
import { setActiveConceptId } from "../../actions";

const ConceptChooser = ({
    className,
    variant = "outlined",
    concepts = [],
    setActiveConceptId,
    activeConceptId
}) => {
    return Object.keys(concepts).length <= 1 ? null : (
        <TextField
            select
            variant={variant}
            className={`concept-chooser ${className}`}
            onChange={evt => setActiveConceptId({activeConceptId: evt.target.value})}
            value={activeConceptId || ''}
        >
            {Object.entries(concepts).map(([, concept]) => (
                <MenuItem key={concept.id} value={concept.id}>{concept.name}</MenuItem>
            ))}
        </TextField>
    );
}



export default connect(
    (state) => ({
        concepts: state.app.concepts,
        activeConceptId: state.app.activeConceptId
    }), {
        setActiveConceptId
    }
)(ConceptChooser);






ConceptChooser.propTypes = {
    className: PropTypes.string
};
ConceptChooser.defaultProps = {
    className: ''
};